export type { i18nFn } from '../../../../../../../types';

export enum EPersonType {
  INDIVIDUAL = 'PF',
  COMPANY = 'PJ',
}

export enum EConsumerStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum EScoreInfoSection {
  REGISTRATION = 'registration',
  CONTACT = 'contact',
  ADDRESS = 'address',
}

export type CollapsibleElement = HTMLElement & { value?: boolean };

export interface IPersonalData {
  cpf: string;
  nome: string;
  nomeMae: string;
  dataNascimento: string;
  nacionalidade: string;
  obito: string;
  escolaridade: string;
}

export interface ICompanyData {
  cnpj: string;
  razaoSocial: string;
  nomeFantasia: string;
  natureza: string;
  situacaoCnpj: string;
  atividadePrincipal: string;
  dataAbertura: string;
  capitalSocial: string;
  dataCapitalSocial: string;
}

export interface IContactInfo {
  telefonePrincipal: string;
  telefoneSecundario: string;
}

export interface IAddressInfo {
  rua: string;
  bairro: string;
  cidade: string;
  complemento: string;
  estado: string;
  cep: string;
}

export interface IConsumerStatusInfo {
  title: string;
  subtitle: string;
  status: EConsumerStatus;
  statusLabel: string;
}

export interface IClientInfoData {
  personType: EPersonType;
  personalData?: IPersonalData;
  companyData?: ICompanyData;
  contact: IContactInfo;
  addresses: IAddressInfo[];
  consumerStatus: IConsumerStatusInfo;
}
